import { VueConstructor } from 'vue';
import { capitalize, capitalizeAll } from '@/helpers/string';

export default function(Vue: VueConstructor) {
    Vue.filter(`capitalize`, (word: str) => capitalize(word));
    Vue.filter(`capitalizeAll`, (word: str) => capitalizeAll(word));
}
